/**
 * Load GA4 functions
 * */

(function (pmw, undefined) {

	pmw.getGA4OrderItems = function () {

		// "item_id"      : "34",
		// "item_name"    : "Hoodie",
		// "quantity"     : 1,
		// "item_brand"   : "",
		// "item_variant" : "Color: blue | Logo: yes",
		// "price"        : 45,
		// "currency"     : "CHF",
		// "item_category": "Hoodies"


		let orderItems = [];

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			const parentProduct = pmw.getDataLayerProduct(item.id);
			const variation     = 0 !== item.variation_id ? pmw.getDataLayerProduct(item.variation_id) : null;
			const product       = variation || parentProduct;

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole transaction.
			if (!product) {
				pmw.console.warn("GA4: skipped an order item without product data: " + item.id);
				return;
			}

			let orderItem = {
				quantity     : item.quantity,
				price        : item.price,
				item_name    : item.name,
				currency     : pmwDataLayer.order.currency,
				item_category: ( parentProduct?.category || [] ).join("/"),
			};

			// Check if the item has custom parameters
			if (item?.custom_parameters) {
				// Iterate through each key-value pair in custom parameters
				Object.keys(item.custom_parameters).forEach((key) => {
					// Add each custom parameter to the orderItem object
					orderItem[key] = item.custom_parameters[key];
				});
			}

			orderItem.item_id    = String(product.dyn_r_ids[pmwDataLayer.pixels.google.analytics.id_type]);
			orderItem.item_brand = product.brand;

			if (variation) orderItem.item_variant = variation.variant_description;

			orderItems.push(orderItem);
		});

		return orderItems;
	};

	pmw.ga4AddFormattedCategories = (item_data, categories) => {

		let maxCategories = 5;

		// remove categories with equal names from array
		categories = Array.from(new Set(categories));

		if (Array.isArray(categories) && categories.length) {

			item_data["item_category"] = categories[0];

			let max = categories.length > maxCategories ? maxCategories : categories.length;

			for (let i = 1; i < max; i++) {
				item_data["item_category" + (i + 1)] = categories[i];
			}
		}

		return item_data;
	};

	pmw.getCartItemsGa4 = () => {

		let data = [];

		Object.values(pmwDataLayer.cart).forEach(product => {
			data.push(pmw.ga4GetFullProductItemData(product));
		});

		return data;
	};

	pmw.ga4GetBasicProductItemData = (product) => {

		return {
			item_id  : product.dyn_r_ids[pmwDataLayer.pixels.google.analytics.id_type],
			item_name: product.name,
			// coupon   : "",
			// discount: 0,
			// affiliation: "",
			item_brand  : product.brand,
			item_variant: product.variant,
			price       : product.price,
			currency    : pmwDataLayer?.shop?.currency,
			quantity    : product.quantity,
		};
	};

	pmw.ga4AddListNameToProduct = (item_data, productPosition = null) => {

		item_data.item_list_name = pmwDataLayer.shop.list_name;
		item_data.item_list_id   = pmwDataLayer.shop.list_id;

		if (productPosition) {
			item_data.index = productPosition;
		}

		return item_data;
	};

	pmw.ga4GetFullProductItemData = (product) => {

		let item_data;

		item_data = pmw.ga4GetBasicProductItemData(product);
		item_data = pmw.ga4AddListNameToProduct(item_data, product.position);
		item_data = pmw.ga4AddFormattedCategories(item_data, product.category);

		return item_data;
	};

}(window.pmw = window.pmw || {}));
